// extracted by mini-css-extract-plugin
export default {"root":"lvVrvpjRoVYJyI34lGMB","deleteButton":"CCl6JSpjxNffRqFKV6Ug","noFiltersMessage":"jIzI3qsoQ5oA8Tdhb2Yn","addButton":"KNACKHK5Jgio35YAc6Et"};